import HTForm from '../../_shared/form/htform';

export default class FloorAreaForm extends HTForm {
    setup() {
        return {
            fields: [
                {
                    name: 'floorareaintro',
                    type: 'formsection',
                    label: 'What counts as a main living room?',
                    fields: [
                        {
                            name: 'floorareaintrocontent',
                            type: 'content',
                            extra: {
                                description: () => {
                                    return this.getDescription([
                                        "<p>For these questions, 'main living room' means the whole space a living-room heater must be able to heat. Include any connected spaces that cannot be closed off. We’ll ask you questions about your walls, floor and ceiling, and about your windows, skylights, doors, stairs and insulation.</p>",
                                        `<p>${this.getHelpLink(3, 'Understanding what main living room space to include', 'help-living_space')}</p>`
                                    ]);
                                }
                            }
                        }
                    ]
                },
                {
                    name: 'floorarea',
                    type: 'formsection',
                    value: null,
                    label: 'Floor area',
                    fields: [
                        {
                            name: 'area',
                            type: 'numberfield',
                            label: 'What is the floor area of your main living room?',
                            placeholder: 'Area',
                            value: null,
                            rules: 'required|numeric|greaterthan:0',
                            extra: {
                                unit: 'm2',
                                description: () => {
                                    return this.getDescription([
                                        `<p>${this.getHelpLink(4, 'Working out the floor area of a room', 'help-floor_area')}</p>`
                                    ]);
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'formsection',
                    name: 'stairwells',
                    label: 'Stairs',
                    fields: [
                        {
                            name: '2c-1',
                            type: 'radio',
                            value: 'no',
                            label:
                                'Does your main living room have a staircase that it is always open to?',
                            rules: 'required',
                            extra: {
                                options: () => {
                                    return [
                                        { value: 'no', label: 'No' },
                                        { value: 'yes', label: 'Yes' }
                                    ];
                                },
                                description: () => {
                                    return this.getDescription([
                                        '<p>If your main living room has a staircase it is always open to, we will need some information about any connected rooms or hallways on the additional levels. This helps us understand if a heater needs to heat any extra space on additional levels.</p>',
                                        `<p>${this.getHelpLink(5, 'Understanding whether your room is always open to a staircase', 'help-staircases')}</p>`
                                    ]);
                                }
                            },
                            observers: [
                                {
                                    key: 'value',
                                    call: ({ form, field, change }) => {
                                        if (change.newValue === 'yes') {
                                            this.store.appStore.setStairwells(1);
                                            this.$('stairwells.2c-2').set('value', 1);
                                        } else {
                                            this.store.appStore.setStairwells(0);
                                            this.$('stairwells.2c-2').set('value', 0);
                                            if (this.$('room2.room2area')) {
                                                this.$('room2.room2area').set('value', '');
                                            }
                                            if (this.$('room3.room3area')) {
                                                this.$('room3.room3area').set('value', '');
                                            }
                                        }
                                        !form.isValid && form.validate();
                                    }
                                }
                            ]
                        },
                        {
                            name: '2c-2',
                            type: 'stepper',
                            value: 0,
                            label:
                                'How many staircases does your main living room have?',
                            rules: 'required|numeric|between:0,2',
                            extra: {
                                min: 1,
                                max: 2,
                                showIf: {
                                    '===': [{ var: '2c-1' }, 'yes']
                                }
                            },
                            observers: [{
                                key: 'value', // can be any prop
                                call: ({ form, field, change }) => {
                                    this.store.appStore.setStairwells(parseInt(change.newValue, 10));
                                    switch (change.newValue) {
                                        case 0:
                                            if (this.$('room2.room2area')) {
                                                this.$('room2.room2area').set('value', '');
                                            }
                                            if (this.$('room3.room3area')) {
                                                this.$('room3.room3area').set('value', '');
                                            }
                                            break;
                                        case 1:
                                            if (this.$('room3.room3area')) {
                                                this.$('room3.room3area').set('value', '');
                                            }
                                            break;
                                    }
                                }
                            }]

                        }
                    ]
                },
                {
                    type: 'formsection',
                    name: 'room2',
                    label: 'Additional level 1',
                    extra: {
                        showIf: {
                            '===': [{ var: '2c-1' }, 'yes']
                        }
                    },
                    fields: [
                        {
                            name: 'room2area',
                            type: 'numberfield',
                            value: null,
                            label:
                                'What is the floor area of the rooms or hallways on this level, that are always open to your staircase?',
                            rules: 'required|numeric|greaterthan:0',
                            extra: {
                                unit: 'm2',
                                description: () => {
                                    return this.getDescription([
                                        '<p>This helps us understand the extra space a heater must heat.</p>',
                                        `<p>${this.getHelpLink(4, 'Working out the floor area of a room', 'help-floor_area')}</p>`
                                    ]);
                                }
                            }
                        }
                    ]
                },
                {
                    type: 'formsection',
                    name: 'room3',
                    label: 'Additional level 2',
                    extra: {
                        showIf: {
                            and: [
                                { '===': [{ var: '2c-1' }, 'yes'] },
                                { '>=': [{ var: '2c-2' }, 2] }
                            ]
                        }
                    },
                    fields: [
                        {
                            name: 'room3area',
                            type: 'numberfield',
                            value: null,
                            label:
                                'What is the floor area of the rooms or hallways always open to your staircase?',
                            rules: 'required|numeric|greaterthan:0',
                            extra: {
                                unit: 'm2',
                                description: () => {
                                    return this.getDescription([
                                        '<p>This helps us understand the extra space a heater must heat.</p>',
                                        `<p>${this.getHelpLink(4, 'Finding the floor area of a room', 'help-floor_area')}</p>`
                                    ]);
                                }
                            }
                        }
                    ]
                }
            ]
        };
    }
}
